import { render } from "./CustomerFormBase.vue?vue&type=template&id=76745ec1"
import script from "./CustomerFormBase.vue?vue&type=script&lang=js"
export * from "./CustomerFormBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__